import moment from "moment";
import { useEffect, useRef, useState } from "react";
import Calendar from "react-calendar";
import { PiCaretDown } from "react-icons/pi";
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Label,
  UncontrolledDropdown,
} from "reactstrap";

const DatePickInput = ({
  value,
  setValue,
  placeholder,
  className,
  parentClassName,
  label,
}) => {
  const ref=useRef();
  const formateDate = (d) => {
    return moment(d)?.format("dddd DD-MM-YY");
  };
  const [isOpen, setisOpen] = useState(false);


useEffect(()=>{
  const listener=(e)=>{
    if(ref.current){
      if(!ref.current?.contains(e?.target))
        setisOpen(false);
    }
  }
  window?.addEventListener("click",listener);

  return ()=>window?.removeEventListener("click",listener)
},[])

  return (
    <div className="position-relative" ref={ref}>
      {label && <Label className="figma-input-label">{label}</Label>}

      <Button
        onClick={() => setisOpen((prev) => !prev)}
        className="bg-transparent p-0 hover-color-primary color-primary-black-3  border-none full-width"
      >
        <div
          style={{
            border: "1px solid rgb(164, 164, 164)",
            borderRadius: "0.5rem",
          }}
          className={`d-flex bg-white align-items-center  px-3 py-3 cursor-pointer position-relative justify-content-between ${className}`}
        >
          <p className="m-0">{value ? formateDate(value) : placeholder}</p>
          <div>
            <PiCaretDown
              style={{
                rotate: isOpen ? "180deg" : "0deg",
                transition: "0.3s ease-in all",
              }}
              size={20}
            />
          </div>
        </div>
      </Button>

      {isOpen && (
        <div
          style={{
            width: "100%",
            animation: "scale-in-normal  0.2s linear 1",
            transformOrigin: "top center",
            borderRadius: "1rem",
            position: "absolute",
            top: "100%",
            zIndex: 20,
            right: 0,
          }}
          className="px-2 py-3 bg-white outer-black-shadow"
        >
          <div>
            <Calendar
              onClickDay={(v) => {
                if (setValue) setValue(v);
                setisOpen(false);
              }}
              tileClassName={(e) => {
                if (formateDate(e?.date) === formateDate(value))
                  return `selected-date`;
              }}
              value={value ?? new Date()}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default DatePickInput;
